import MenuItem from "../../core/components/menu/MenuItem";
import i18n from './../../shared/i18n'
import ConditionReportRequests from "@/modules/condition-report-requests/ConditionReportRequests.vue";

let routes = [
  {
    path: 'condition-report-requests',
    name: 'conditionReportRequests',
    component: ConditionReportRequests,
    meta: {
      requiresAuth: true
    }
  },
];
export default {
  menuItem: new MenuItem('/condition-report-requests', i18n.t('Condition Requests'), 80, 'file-alt', [], 'view_conditionreportrequest'),
  routes: routes
}